<div class="head">
  <div #header>
    <ng-content select="[header]"></ng-content>
  </div>

  <div class="filters">
    @if (shouldFiltersBeInHeader(header) && areFiltersVisible | async) {
    <ng-container [ngTemplateOutlet]="filtersTmpl"></ng-container>
    }
  </div>

  <div class="k2-filters">
    @if (shouldFiltersBeInHeader(header) && areFiltersVisible | async) {
    <ng-container [ngTemplateOutlet]="k2FiltersTmpl"></ng-container>
    }
  </div>

  <div class="buttons">
    <ng-content select="[buttons]"></ng-content>
  </div>
</div>

<intro>
  <ng-content select="[intro]"></ng-content>
</intro>

<div class="filters">
  @if (shouldFiltersBeUnderHeader(header) && areFiltersVisible | async) {
  <ng-container [ngTemplateOutlet]="filtersTmpl"></ng-container>
  }
</div>

<div class="k2-filters">
  @if (shouldFiltersBeUnderHeader(header) && areFiltersVisible | async) {
  <ng-container [ngTemplateOutlet]="k2FiltersTmpl"></ng-container>
  }
</div>

<div *ngSubscribe="items as items">
  @if (items | isNotEmpty) {
  <div class="table table-striped">
    <ng-content select="table"></ng-content>
  </div>
  <ng-content select="[paginator]"></ng-content>
  @if (paginator != null) {
  <paginator
    [paginator]="paginator"
    [customPageSizeOptions]="customPageSizeOptions"
    [alwaysVisible]="alwaysShowPaginator"
  ></paginator>
  } } @if ((items | isEmpty) && !items?.$filtered) {
  <ng-content select="[ifNothing]"></ng-content>
  } @if ((items | isEmpty) && items?.$filtered) {
  <no-data> No results matched your search. </no-data>
  }
</div>

<ng-template #filtersTmpl>
  <ng-content select="[filters]"></ng-content>
</ng-template>

<ng-template #k2FiltersTmpl>
  <ng-content select="[k2-filters]"></ng-content>
</ng-template>
